export interface SlDropdownInterface<T> {
  key: string;
  value: T;
}

export enum TagColorVariants {
  YELLOW = 'yellow-variant',
  ORANGE = 'orange-variant',
  RED = 'red-variant',
  PINK = 'pink-variant',
  PURPLE = 'purple-variant',
  TEAL = 'teal-variant',
  BLUE = 'blue-variant',
  GREEN = 'green-variant',
  GREY = 'grey-variant',
}

export enum TagVariants {
  READONLY = 'read-only',
  DISMISSABLE = 'dismissable',
  OPERATIONAL = 'operational',
  SELECTABLE = 'selectable',
}

export enum TagSize {
  STANDARD = 'standard-size-variant',
  SMALL = 'small-size-variant',
}

export interface TagInterface {
  label: string;
  icon?: string;
  size?: TagSize;
  variant?: TagVariants;
  color?: TagColorVariants;
  operationalContent?: string[];
}
